import React from "react";
import { Button, ButtonProps } from "@mui/material";

export interface ActionButtonProps extends ButtonProps {
  /** "gold" = premium gold gradient CTA, "navy" = solid navy, else MUI default. */
  tone?: "gold" | "navy";
}

/**
 * Primary call-to-action button used in page headers / dialogs. `tone="gold"`
 * is the premium INTALK CTA; `tone="navy"` a solid alternative. Anything else
 * falls back to standard MUI Button props.
 */
export default function ActionButton({ tone = "gold", variant = "contained", sx, children, ...rest }: ActionButtonProps) {
  const toneSx =
    tone === "gold"
      ? {
          background: "linear-gradient(135deg, #058dd0 0%, #3aa9e0 100%)",
          color: "#fff",
          fontWeight: 700,
          boxShadow: "0 6px 16px rgba(5,141,208,0.35)",
          "&:hover": { background: "linear-gradient(135deg, #0477b0 0%, #2ba0db 100%)" },
        }
      : tone === "navy"
      ? {
          background: "linear-gradient(135deg, #0B1E2D 0%, #071521 100%)",
          color: "#fff",
          fontWeight: 700,
          "&:hover": { background: "#0B1E2D" },
        }
      : {};

  return (
    <Button variant={variant} sx={{ borderRadius: "10px", ...toneSx, ...(sx as object) }} {...rest}>
      {children}
    </Button>
  );
}
